import { AssignDocument } from "@pathwright/graphql-client/src/generated"

export default AssignDocument
